export const getUniqueId = () => Date.now().toString(10);
